import ClaimDetailsAdditionalPayments from './ClaimDetailsAdditionalPayments';

export default ClaimDetailsAdditionalPayments;
